<template>
  <div
    class="table-search-container"
  >
    <a-select
      style="width:200px;margin-right:20px;"
      class="select-container"
      placeholder="请选择状态"
      @change="value => $emit('onChangeStatus', value)"
    >
      <a-select-option
        v-for="item in statusData"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <a-input-search
      placeholder="请输入搜索内容"
      style="width:225px;"
      @search="value => $emit('onSearch', value)"
    />
    <a-button
      type="primary"
      shape="round"
      icon="plus"
      @click="$emit('editAndAdd')"
    >
      新增文章
    </a-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      statusData: [
        {id: -1, name: '全部'},
        {id: 1, name: '已发布'},
        {id: 2, name: '未发布'},
        {id: 3, name: '已置顶'},
        {id: 4, name: '未置顶'},
        {id: 5, name: '已推荐'},
        {id: 6, name: '未推荐'},
      ],
    };
  },
  methods: {

  },
};
</script>
<style lang="scss">
.table-search-container {
  height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 15px;
    height: 30px;
  }
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
    margin-left: 20px;
  }
}
</style>
